import React, { useEffect } from 'react';

import {
	useAIProfileData,
	useAISurfaceMetadata,
	useViewAIActions,
} from '@atlassian/ai-smart-button-api';
import { useProfileController } from '@atlassian/conversation-assistant-store';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { useRovoButtonEventsInstrumentation } from '../../../hooks/useRovoButtonEventsInstrumentation';

export const useSharedAISmartButtonLogic = () => {
	const { fireRovoButtonUIEvent } = useRovoButtonEventsInstrumentation();
	const { setProfileData, setShowConvoStarters } = useViewAIActions();
	const surfaceMetadata = useAISurfaceMetadata();
	const profileDataFromStore = useAIProfileData();
	const profileData = useProfileController(profileDataFromStore);
	const hoverTimerRef = React.useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (profileData) {
			setProfileData(profileData);
		}
	}, [profileData, setProfileData]);

	const onAISmartButtonEnter = React.useCallback(() => {
		hoverTimerRef.current = setTimeout(() => {
			fireRovoButtonUIEvent({
				source: surfaceMetadata?.contentType,
				action: 'hovered',
				actionSubject: 'rovoButton',
				actionSubjectId: 'aiSmartButton',
				attributes: {
					product: surfaceMetadata?.product,
					productPage: surfaceMetadata?.contentType,
					pageMode: surfaceMetadata?.pageMode,
				},
				product: surfaceMetadata?.product,
			});
		}, 1000);
	}, [fireRovoButtonUIEvent, surfaceMetadata]);

	const onAISmartButtonLeave = React.useCallback(() => {
		if (hoverTimerRef.current) {
			clearTimeout(hoverTimerRef.current);
			hoverTimerRef.current = null;
		}
	}, []);

	return {
		setShowConvoStarters,
		onAISmartButtonEnter,
		onAISmartButtonLeave,
	};
};
